import * as React from "react";
import { AccuracyGapAnalysisStatus } from "@app/projects/enumerators";
import getAGABanner from "@app/shared/AccuracyGapAnalysisBanner";
import { FlyoutFooter } from "@app/shared/Flyouts";
import ProjectOptions from "@app/projects/projectOptions";
import ProjectService from "@app/projects/projectService";
import { QESAlert } from "@app/shared/qes-standards/Alert";
import { QESButton } from "@app/shared/qes-standards/Button";

interface PublishProps {
  agaStatus?: AccuracyGapAnalysisStatus;
  onPublished?: () => void;
  project: ProjectOptions;
  runConfigurationId: number;
}

interface PublishState {
  publishComment: string;
  submitting: boolean;
}

export default class Publish extends React.Component<PublishProps, PublishState> {
  private readonly projectService = new ProjectService();

  constructor(props: PublishProps) {
    super(props);

    this.state = {
      publishComment: "",
      submitting: false,
    };
  }



  public render() {
    const unprocessedProvidersBanner = (this.props.project.hasUnprocessedProjectionProviders || this.props.project.hasUnprocessedProviderTerminations) ?
      <QESAlert type="warning" key="unprocessedProvidersWarning" persist={true}>
        <strong>Warning! </strong>
        This project has unprocessed targets or terminations that will be automatically processed after publish
      </QESAlert> : <></>

    return (
      <>
        {getAGABanner(this.props.project.showAccuracyGapAnalysis, this.props.agaStatus)}
        {unprocessedProvidersBanner}
        <p>Tag this publication so you can recognize it later...</p>

        <div className="form-horizontal">

          <div className="form-group row">
            <label className="col-sm-2 col-form-label" htmlFor="comment">Publish Tag:</label>
            <div className="col-sm-9">
              <input
                className="form-control"
                id="comment"
                maxLength={50}
                onChange={this.handlePublishCommentChange}
              />
            </div>
          </div>

          <FlyoutFooter
            submitButton={<QESButton
              qesTestId="publish_submit"
              disabled={this.state.submitting}
              onClick={this.handleSubmit}
            >Submit</QESButton>}
          />

        </div>
      </>
    );
  }

  private handleSubmit = async () => {
    this.setState((prevState) => ({
      ...prevState,
      submitting: true,
    }));

    await this.projectService.publishRunConfiguration(
      this.props.project.projectId,
      this.props.runConfigurationId,
      this.state.publishComment);

    if (this.props.onPublished) {
      this.props.onPublished();
    }
  }

  private handlePublishCommentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      publishComment: e.currentTarget.value
    });
  }
}
